import { Fragment } from "react";
import style from "./ExternalAddressView.module.css";
import { Col, Form } from "react-bootstrap";

function ExternalAddressView({ information }) {
  const checkExits = (item, value, parentheses = true, nextLine = false) => {
    if (item) {
      return item[value]
        ? (nextLine ? "\n" : "") +
            (parentheses ? "(" : "") +
            item[value] +
            (parentheses ? ")" : "")
        : "";
    }
    return "";
  };

  return (
    <section className={"d-flex flex-wrap mb-4 " + style.box}>
      {information.type === 0 ? (
        <Fragment>
          <Col>
            <Form.Label>نام: </Form.Label>
            <Form.Control
              disabled={true}
              value={`${information.name} ${checkExits(
                information.address_external,
                "name"
              )}`}
            />
          </Col>

          <Col>
            <Form.Label>
              <span>نام خانوادگی: </span>
            </Form.Label>
            <Form.Control
              disabled={true}
              value={`${information.family} ${checkExits(
                information.address_external,
                "family"
              )}`}
            />
          </Col>
        </Fragment>
      ) : (
        <Col>
          <Form.Label>
            <span>نام شرکت: </span>
          </Form.Label>
          <Form.Control
            disabled={true}
            value={`${information.compony} ${checkExits(
              information.address_external,
              "company"
            )}`}
          />
        </Col>
      )}

      <Col>
        <Form.Label>
          <span>موبایل: </span>
        </Form.Label>
        <Form.Control disabled={true} value={information.phone ?? ""} />
      </Col>

      <Col>
        <Form.Label>
          <span>ایمیل: </span>
        </Form.Label>
        <Form.Control disabled={true} value={information.email ?? ""} />
      </Col>

      <Col>
        <Form.Label>
          <span>تلفن ثابت: </span>
        </Form.Label>
        <Form.Control disabled={true} value={information.tel ?? ""} />
      </Col>

      <Col>
        <Form.Label>
          <span>کدپستی: </span>
        </Form.Label>
        <Form.Control disabled={true} value={information.postCode ?? ""} />
      </Col>

      <Col>
        <Form.Label>
          <span>کشور: </span>
        </Form.Label>
        <Form.Control
          disabled={true}
          value={
            checkExits(information.country_name, "faName", false) +
            " " +
            checkExits(information.country_name, "enName")
          }
        />
      </Col>

      <Col>
        <Form.Label>
          <span>شهر: </span>
        </Form.Label>
        <Form.Control
          disabled={true}
          value={
            checkExits(information.address_external, "fa_city_name", false) +
            " " +
            checkExits(information.address_external, "en_city_name")
          }
        />
      </Col>

      <Col className="w-100">
        <Form.Label>
          <span>آدرس: </span>
        </Form.Label>
        <Form.Control
          className="text-end"
          disabled={true}
          as="textarea"
          value={`${information.address} ${checkExits(
            information.address_external,
            "address",
            false,
            true
          )}`}
        />
      </Col>
    </section>
  );
}

export default ExternalAddressView;
